export type PrizmDocDemoNextVersion = '1.next' | '2.next' | '3.next' | '4.next';
export type PrizmDocDemoBetaVersion = '1.beta' | '2.beta' | '3.beta' | '4.beta';
export type PrizmDocDemoMainVersion = '1' | '2' | '3' | '4';
export type PrizmDocDemoVersion = PrizmDocDemoMainVersion | PrizmDocDemoNextVersion | PrizmDocDemoBetaVersion;
